import React from 'react';

const TermsConditionsPage = () => {
  return (
    <div className="min-h-screen bg-[#F5F5DC] pt-40 pb-20 px-6 max-w-3xl mx-auto text-left font-sans text-[#2C1E12]">
      <h2 className="text-3xl font-serif uppercase tracking-wider mb-2">Terms & Conditions</h2>
      <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-8 border-b border-[#2C1E12]/10 pb-4">Merchant Agreement Framework Ledger</p>
      
      <div className="space-y-6 text-xs leading-relaxed font-serif text-zinc-700">
        <p>Welcome to **Modische Kledings**. By accessing our site, logging profiles, and finishing payment transaction checkout rows, you agree to comply with our commercial operating guidelines:</p>
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">1. Customer Identification & Security</h4>
          <p>Users must submit valid credentials during authentication token exchanges. All monetary transactions are safely processed by authorized gateway systems (Razorpay). You are entirely accountable for preserving the privacy parameters of your system access logs.</p>
        </div>
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">2. Pricing & Precision Fault Restrictions</h4>
          <p>We work to prevent sizing metrics typos or discount valuation discrepancy flags. If an inventory line item is posted with an inaccurate price parameter, Modische Kledings maintains the legal right to void checkout arrays and issue immediate credit balance adjustments.</p>
        </div>
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">3. Corporate Entity Governance & Jurisdiction</h4>
          <p>These compliance guidelines are regulated under the laws of India. Any litigation conflicts or structural transaction disputes originating from store operations will be managed under the absolute jurisdiction of the courts sitting in **Indore, Madhya Pradesh** corresponding to our physical corporate ledger footprint at:</p>
          <p className="mt-2 font-mono text-[11px] font-bold text-[#2C1E12] bg-white/50 p-2 border border-[#E5D3B3] rounded-xs max-w-xl">
            15-345, RAM RAHIM COLONY BEHIND PAPAYA TREE, RAU, INDORE, MADHYA PRADESH, PIN: 453331
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsConditionsPage;